export default "__VITE_ASSET__c19be12f__"